import { createAction, props } from '@ngrx/store';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { ExtensionGroupRegisterListItem } from '../models/extension-register-results.model';
import { ExtensionGroupsFilterOption } from '../models/extensions-group-filter-option';

const area = 'ExtensionGroups Register';
export const extensionGroupRegisterAdapterActions = createRegisterActions<ExtensionGroupRegisterListItem>(area);

export const createExtensionGroup = createAction(`[${area}] Create ExtensionGroup`);

export const extensionGroupRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: ExtensionGroupsFilterOption[] }>()
);
